export const ROUTES = {
  base: '/',
  login: '/login',
  signup: '/signup',
  insurance: '/insurance',
  verify: '/verify',
  changePassword: '/change-pin',
  dashboard: '/dashboard',
  notifications: '/notifications',
  resetPassword: '/reset-pin',
  resetPin: '/reset-otp',
  buyGadget: {
    base: '/buy-gadget',
    policy: '/buy-gadget/policy',
    summary: '/buy-gadget/summary',
    payment: '/buy-gadget/payment'
  },
  buyMotor: {
    base: '/buy-motor',
    details: '/buy-motor/details',
    policy: '/buy-motor/policy',
    summary: '/buy-motor/summary',
    payment: '/buy-motor/payment',
    enter: '/buy-motor/enter-details'
  },
  quotes: {
    base: '/quotes',
    details: '/quotes/:id'
  },
  policies: {
    base: '/policies',
    details: '/policies/:id'
  },
  settings: {
    base: '/settings',
    profile: '/settings/profile',
    security: '/settings/security',
    claims: '/settings/claims',
    faqs: '/settings/faqs',
    privacyPolicy: '/settings/privacy-policy',
    tAndC: '/settings/terms-conditions'
  }
}
